import { Grid, Typography, useMediaQuery } from "@mui/material";
import { Labeled, useRecordContext } from "react-admin";

import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";
import DocumentFileLink from "../../Partials/DocumentFileLink";

// The record carries document ids, not files - the link downloads by id.
const DocumentItem = ({ label, documentId }) => (
  <Grid
    item
    xs={12}
    md={3}
  >
    <Labeled label={label}>
      {documentId ? (
        <DocumentFileLink
          id={documentId}
          documentName={label}
        />
      ) : (
        <Typography>-</Typography>
      )}
    </Labeled>
  </Grid>
);

const DocumentsSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();

  const userInfo = record?.userInfo;

  if (!userInfo) return null;

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Документи"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <DocumentItem
          label="CV"
          documentId={userInfo.cvDocumentId}
        />
        <DocumentItem
          label="Номинационно писмо"
          documentId={userInfo.nominationLetterDocumentId}
        />
        <DocumentItem
          label="Снимка"
          documentId={userInfo.photoDocumentId}
        />
        <DocumentItem
          label="Мотивационно писмо"
          documentId={userInfo.motivationLetterDocumentId}
        />
      </Grid>
    </>
  );
};

export default DocumentsSection;
